<template>

  <va-navbar color="#0099FF" class="mb-2">
    <template #left>
      <va-navbar-item><img alt="Punterforum" src="./assets/logo.png" width="150" height="150"></va-navbar-item>
    </template>
    <template #center>
      <va-navbar-item><a href="https://punterforum.com">Home</a></va-navbar-item>
      <va-navbar-item><a href="https://escorthub.punterforum.com">EscortHub</a></va-navbar-item>
      <va-navbar-item><a href="https://community.punterforum.com">Community</a></va-navbar-item>
      <va-navbar-item><a href="https://punterforum.com/blog/">Blog</a></va-navbar-item>
      <va-navbar-item><a href="https://punterforum.com/regolamenti/">Regolamenti</a></va-navbar-item>
      <va-navbar-item><a href="https://punterforum.com/contatti/">Contatti</a></va-navbar-item>
    </template>
  </va-navbar>
  <HelloWorld msg="Punterforum, web authority escort reviews since 2007"/>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--va-darkest-gray);
  margin: 30px;
}
.va-navbar__item a:link,
.va-navbar__item a:visited {
  color: #ffffff;
}
</style>
